import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import React, { Component } from "react";
import ComboCodeValidator from "./ComboCodeValidator";
import ComboCodeValidation from "../ComboCodeValidationAlerts/ComboCodeValidation";
import countryWithStates from "../../const/countryWithStates";
import "../../layout/layout.scss";
import "./LodingIndicator.scss";
import "./ComboCode.scss";
import { fetchRecommendedAddress } from "../../api/CartApi";
import { addressValidationFields } from "../../const/AddressValidations";
import AddressDoctorModal from "../AddressDoctorModal/AddressDoctorModal";
import { addressFormat, checkForm, setErrors } from "./ComboCodeUtility";
var recommendedAddress = [];
var userEnteredAddress = {};
var addressLine2;

var ComboCode = /*#__PURE__*/function (_Component) {
  _inherits(ComboCode, _Component);

  function ComboCode(props) {
    var _this;

    _classCallCheck(this, ComboCode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComboCode).call(this, props));

    _this.timeOutError = function (input) {
      setTimeout(function () {
        document.getElementById(input).focus();
      }, 2000);
    };

    _this.handleChange = function (event) {
      _this.setState(_defineProperty(_defineProperty({}, event.target.name, event.target.value), "hasAddressEdit", true), function () {});
    };

    _this.triggerClick = function () {
      _this.setState({
        submitButtonClicked: true
      }, function () {});
    };

    _this.handleFormSubmit = function () {
      _this.setState({
        "adTriggered": false
      });

      _this.closeModal();

      _this.setState({
        hasAddressEdit: false,
        showAddressValidateAlert: false
      });

      _this.props.successCallback({
        firstName: _this.state.firstName,
        lastName: _this.state.lastName,
        phoneNumber: _this.state.phoneNumber,
        addressLine1: _this.state.addressLine1,
        addressLine2: _this.state.addressLine2,
        city: _this.state.city,
        state: _this.state.stateOrProvince,
        postalCode: _this.state.postalCode,
        countryIsoCode: "US",
        type: "BILLING_AND_SHIPPING",
        country: "United States"
      });

      _this.setState({
        submitButtonClicked: false
      }, function () {});
    };

    _this.callAddressDoctor = function (event) {
      event.preventDefault();

      _this.setState({
        "adTriggered": true
      });

      fetchRecommendedAddress(_this.props.userToken, _this.props.environment, {
        orderId: _this.props.orderId,
        address: {
          addressLine1: addressFormat(_this.state.addressLine1),
          city: addressFormat(_this.state.city),
          postalCode: _this.state.postalCode,
          country: _this.state.country,
          stateOrProvince: _this.state.stateOrProvince,
          isoCountry: "US"
        }
      }, _this.handleRecommendedAddress);
    };

    _this.updateShippingForm = function (addressLine1, city, postalCode, isoCountry, stateOrProvince, country) {
      _this.setState({
        addressLine1: addressLine1,
        city: city,
        postalCode: postalCode,
        isoCountry: isoCountry,
        stateOrProvince: stateOrProvince,
        country: country,
        isModalVisible: false
      }, function () {
        this.handleFormSubmit();
      });
    };

    _this.isSaveDisabled = function () {
      var formElements = document.querySelectorAll("[aria-required='true']");
      var isFormFilled = checkForm(formElements);

      if (isFormFilled) {
        return !_this.state.hasAddressEdit || Object.keys(_this.state.errors).length > 0;
      } else {
        return _this.state.hasAddressEdit || !Object.keys(_this.state.errors).length > 0;
      }
    };

    _this.clientSideValidation = function (event) {
      var errors = setErrors(event, _this.state.errors);

      _this.setState({
        errors: errors
      });
    }; //accessibility & UX related functions


    _this.handleInputAria = function (event) {
      var errors = _this.state.errors;

      if (event.target.id === 'cc-firstName') {
        _this.handleAria(errors["firstName"], event.target.id);
      } else if (event.target.id === 'cc-lastName') {
        _this.handleAria(errors["lastName"], event.target.id);
      } else if (event.target.id === 'addressLine1') {
        _this.handleAria(errors["addressLine1"], event.target.id);
      } else if (event.target.id === 'addressLine2') {
        _this.handleAria(errors["addressLine2"], event.target.id);
      } else if (event.target.id === 'cc-city') {
        _this.handleAria(errors["city"], event.target.id);
      } else if (event.target.id === 'c-state') {
        _this.handleAria(errors["stateOrProvince"], event.target.id);
      } else if (event.target.id === 'cc-zip-code') {
        _this.handleAria(errors["postalCode"], event.target.id);
      } else if (event.target.id === 'phoneNumber') {
        _this.handleAria(errors["phoneNumber"], event.target.id);
      }
    };

    _this.handleFormSubmit = _this.handleFormSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleAria = _this.handleAria.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.timeOutError = _this.timeOutError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.callAddressDoctor = _this.callAddressDoctor.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleRecommendedAddress = _this.handleRecommendedAddress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleAddressValidateAlertVisibility = _this.handleAddressValidateAlertVisibility.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.validator = new ComboCodeValidator(addressValidationFields);
    _this.state = {
      isSkipAlertShow: false,
      isModalVisible: false,
      firstName: "",
      lastName: "",
      addressLine1: "",
      addressLine2: "",
      apartment: "",
      city: "",
      country: "United States",
      stateOrProvince: "",
      phoneNumber: "",
      postalCode: "",
      validation: _this.validator.valid(),
      selectedView: "UK",
      submitted: false,
      country_states: countryWithStates,
      submitButtonClicked: false,
      errors: {},
      showAddressValidateAlert: false,
      hasAddressEdit: false
    };
    return _this;
  }

  _createClass(ComboCode, [{
    key: "handleRecommendedAddress",
    value: function handleRecommendedAddress(response) {
      //AD API available
      if (response.status === 200) {
        recommendedAddress = response.data; // no address suggestion

        if (response.data.length === 0) {
          this.setState({
            "adTriggered": false
          });
          this.handleAddressValidateAlertVisibility(); // 1 or more address suggestions
        } else {
          var hasExactMatch = false;
          response.data.map(function (addressObjectMapped, index) {
            if (addressObjectMapped.mailabilityScore >= 4 && addressObjectMapped.resultPercentage >= 85) {
              hasExactMatch = true;
            }
          });

          if (hasExactMatch) {
            this.setState({
              "adTriggered": false
            });
            this.handleFormSubmit();
          } else {
            this.openModal();
          }
        } //AD not available. Let user to proceed. 

      } else {
        this.setState({
          "adTriggered": false
        });
        this.handleFormSubmit();
      }
    }
  }, {
    key: "openModal",
    value: function openModal() {
      if (this.state.addressLine2 !== undefined) {
        addressLine2 = addressFormat(this.state.addressLine2);
      }

      userEnteredAddress = {
        addressLine1: addressFormat(this.state.addressLine1),
        city: addressFormat(this.state.city),
        stateOrProvince: this.state.stateOrProvince,
        postalCode: this.state.postalCode,
        countryIsoCode: "US",
        country: "United States"
      };
      this.setState({
        isModalVisible: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        "adTriggered": false
      });
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleAddressValidateAlertVisibility",
    value: function handleAddressValidateAlertVisibility() {
      this.setState({
        showAddressValidateAlert: true
      });
      setTimeout(function () {
        document.getElementById('combo-api-error').scrollIntoView({
          behavior: "smooth"
        });
      }, 500);
    }
  }, {
    key: "handleAria",
    value: function handleAria(errorName, elementName) {
      if (errorName === "" || errorName === undefined) {
        document.getElementById(elementName).removeAttribute("aria-invalid");
      } else {
        document.getElementById(elementName).setAttribute("aria-invalid", true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var validation = this.submitted ? // if the form has been submitted at least once
      this.validator.validate(this.state) : // then check validity every time we render
      this.state.validation; // otherwise just use what's in state

      return /*#__PURE__*/React.createElement("div", {
        className: "sfc-form",
        id: "address-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "address-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkout-step shipping-address"
      }, this.state.showAddressValidateAlert === true && /*#__PURE__*/React.createElement(ComboCodeValidation, null), /*#__PURE__*/React.createElement("form", {
        className: "combo-code-form",
        id: "billingAddressForm",
        name: "billingAddressForm"
      }, /*#__PURE__*/React.createElement("div", {
        className: "titleSection"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "step-title"
      }, "Tell us where to send your loose-leaf version"), /*#__PURE__*/React.createElement("small", {
        className: "billingsmall"
      }, /*#__PURE__*/React.createElement("i", null, "* Required"))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row input-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6 sfc-cc-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.firstName ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-firstName"
      }, "First name", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control",
        name: "firstName",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 17,
        "aria-describedby": "c-fname",
        "aria-required": "true",
        id: "cc-firstName",
        value: this.state.firstName,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        id: "c-fname",
        className: "help-block error-icon",
        role: "status"
      }, this.state.errors.firstName))), /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.lastName ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-lastName"
      }, "Last name", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control",
        name: "lastName",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 17,
        "aria-describedby": "c-lname",
        "aria-required": "true",
        id: "cc-lastName",
        value: this.state.lastName,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-lname",
        role: "status"
      }, this.state.errors.lastName)))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row input-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6 sfc-cc-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.addressLine1 ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "addressLine1"
      }, "Street address", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control addressLine1",
        name: "addressLine1",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 35,
        "aria-describedby": "c-address1",
        "aria-required": "true",
        id: "addressLine1",
        value: this.state.addressLine1,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("label", {
        className: "label-po-box"
      }, "We are unable to ship to P.O. boxes"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-address1",
        role: "status"
      }, this.state.errors.addressLine1))), /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.addressLine2 ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-state"
      }, "Apartment/Suite/Building"), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control apartment",
        name: "addressLine2",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 35,
        "aria-describedby": "c-state",
        id: "addressLine2",
        value: this.state.addressLine2,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-address2",
        role: "status"
      }, this.state.errors.addressLine2)))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row input-row country-state-zip"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6 sfc-cc-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.city ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-city"
      }, "City", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control",
        name: "city",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 40,
        "aria-describedby": "c-city",
        "aria-required": "true",
        id: "cc-city",
        value: this.state.city,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-city",
        role: "status"
      }, this.state.errors.city))), /*#__PURE__*/React.createElement("div", {
        className: "cc-md-3 cc-sm-3 state sfc-cc-state"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.stateOrProvince ? 'has-error' : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "c-state"
      }, "State", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("div", {
        className: "select-div"
      }, /*#__PURE__*/React.createElement("select", {
        "aria-describedby": "c-state2",
        id: "c-state",
        "aria-label": "state",
        "aria-required": "true",
        className: "cc-form-control state",
        name: "stateOrProvince",
        value: this.state.stateOrProvince,
        autoComplete: "on",
        onFocus: this.handleInputAria,
        onBlur: this.clientSideValidation,
        onChange: this.handleChange
      }, this.state.country_states["USA"].map(function (country_states) {
        return /*#__PURE__*/React.createElement("option", {
          key: country_states
        }, " ", country_states);
      })), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-state2",
        role: "status"
      }, this.state.errors.stateOrProvince)))), /*#__PURE__*/React.createElement("div", {
        className: "cc-md-3 cc-sm-3 zip"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.postalCode ? 'has-error' : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-zip-code"
      }, "Zip code", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control zip-code",
        name: "postalCode",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        maxLength: 10,
        "aria-describedby": "c-zip",
        "aria-required": "true",
        id: "cc-zip-code",
        value: this.state.postalCode,
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-zip",
        role: "status"
      }, this.state.errors.postalCode)))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row input-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6 sfc-cc-left sfc-cc-country"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-country"
      }, "Country", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "country",
        className: "cc-form-control country",
        name: "country",
        value: "United States",
        readOnly: true,
        "aria-describedby": "c-country",
        id: "cc-country"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-country",
        role: "status"
      }, validation.country.message))), /*#__PURE__*/React.createElement("div", {
        className: "cc-sm-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: this.state.errors.phoneNumber ? "has-error" : undefined
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "cc-phone-number"
      }, "Phone number", /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "cc-form-control phone",
        name: "phoneNumber",
        maxLength: "10",
        onBlur: this.clientSideValidation,
        onFocus: this.handleInputAria,
        onChange: this.handleChange,
        "aria-describedby": "c-phone",
        "aria-required": "true",
        id: "cc-phone-number",
        autoComplete: "on"
      }), /*#__PURE__*/React.createElement("span", {
        className: "help-block error-icon",
        id: "c-phone",
        role: "status"
      }, this.state.errors.phoneNumber)))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cc-lg-12"
      }, /*#__PURE__*/React.createElement("label", {
        className: "label-ground-ship",
        htmlFor: "address"
      }, "Ground shipping: 3 to 8 business days", /*#__PURE__*/React.createElement("br", null), "Remote areas and Alaska & Hawaii may take longer."))), /*#__PURE__*/React.createElement("div", {
        className: "cc-row btn-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sfc-cc-buttons validating"
      }, this.state.adTriggered ? /*#__PURE__*/React.createElement("div", {
        className: "ad-validate-spinner"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        onClick: this.callAddressDoctor,
        onMouseDown: this.triggerClick,
        className: "btn btn-primary btn-send-it",
        disabled: this.isSaveDisabled()
      }, "Validating", /*#__PURE__*/React.createElement("div", {
        className: "gr-loading-indicator-wrapper",
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuetext": "Loading Indicator",
        "aria-label": "Loading"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loading-indicator"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loading-spinner"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container-one"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle3"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle4"
      })), /*#__PURE__*/React.createElement("div", {
        className: "container-two"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle3"
      }), /*#__PURE__*/React.createElement("div", {
        className: "circle4"
      }))))))) : /*#__PURE__*/React.createElement("button", {
        type: "submit",
        onClick: this.callAddressDoctor,
        onMouseDown: this.triggerClick,
        className: "btn btn-primary btn-send-it",
        disabled: this.isSaveDisabled()
      }, "Use this address")), /*#__PURE__*/React.createElement(AddressDoctorModal, {
        addressLine2: addressLine2,
        modalVisibility: this.state.isModalVisible,
        userEnteredAddress: userEnteredAddress,
        recommendedAddress: recommendedAddress,
        handleFormSubmit: function handleFormSubmit(event) {
          return _this2.handleFormSubmit(event);
        },
        closeModal: function closeModal() {
          return _this2.closeModal();
        },
        handleAddressValidateAlertVisibility: function handleAddressValidateAlertVisibility() {
          return _this2.handleAddressValidateAlertVisibility();
        },
        updateShippingForm: function updateShippingForm(addressLine1, city, postalCode, isoCountry, stateOrProvince, country) {
          return _this2.updateShippingForm(addressLine1, city, postalCode, isoCountry, stateOrProvince, country);
        }
      }))))));
    }
  }]);

  return ComboCode;
}(Component);

export default ComboCode;